import React from 'react';
import PropTypes from 'prop-types';
import { StyledModal, StyledModalHeader } from '../../form/FormElements';
import UploadForm from './UploadForm';
import { useTranslation } from 'react-i18next';
import { useUploadFileMutation } from '../../../../redux/services/filesApi';

const FileUploadModal = ({
  open,
  toggle,
  onSuccessUpload,
  uploadDirectory = undefined,
  allowedTypes = undefined,
  errorMessage = undefined,
  enableCustomFileName = false,
  initialText = '',
}) => {
  const { t } = useTranslation();

  const [uploadFile] = useUploadFileMutation();

  const handleFileUpload = (fileData, clearFileList) => {
    // Odstráni diakritiku, nahradí nebezpečné znaky a medzery v názve súboru
    let safeFileName = fileData.file.name
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '') // odstráni diakritiku
      .replace(/[^a-zA-Z0-9.\-_]/g, '_') // nahradí nebezpečné znaky a medzery za _
      .replace(/\s+/g, '_'); // nahradí medzery za _ (pre istotu)

    const safeFile = new File([fileData.file], safeFileName, {
      type: fileData.file.type,
    });

    uploadFile({
      file: safeFile,
      directory: uploadDirectory,
    })
      .unwrap()
      .then((res) => {
        // Pridáme vlastný názov súboru do odpovede pre rodiča
        onSuccessUpload({ ...res, customName: fileData.customName });
        clearFileList();
      })
      .catch((e) => console.warn(e));
  };

  return (
    <StyledModal open={open} size="md" onCancel={() => toggle()} footer={null}>
      <StyledModalHeader>{t('Nahratie súboru')}</StyledModalHeader>
      <div style={{ padding: '10px' }}>
        <UploadForm
          onFileUpload={handleFileUpload}
          allowedTypes={allowedTypes}
          errorMessage={errorMessage}
          enableCustomFileName={enableCustomFileName}
          initialText={initialText}
        />
      </div>
    </StyledModal>
  );
};

FileUploadModal.propTypes = {
  open: PropTypes.bool,
  toggle: PropTypes.func,
  onSuccessUpload: PropTypes.func, // (cestaKSuboru) => {},
  uploadDirectory: PropTypes.string,
  allowedTypes: PropTypes.arrayOf(PropTypes.string),
  apiErrorMessage: PropTypes.func,
  enableCustomFileName: PropTypes.bool,
  initialText: PropTypes.string,
};

export default FileUploadModal;
